import React from "react";
import styled from "styled-components";

function VideoCareer({ videos }) {
  return (
    <Container>
      {videos.map((video, index) => (
        <Slot key={index}>{video}</Slot>
      ))}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 40px 0;

  @media only screen and (max-width: 1200px) {
    padding: 20px 0;
  }

  @media only screen and (max-width: 768px) {
    padding: 15px 0;
  }
`;

const Slot = styled.div`
  width: 30%;
  height: 300px;
  margin: 15px;
  border-radius: 15px;

  @media only screen and (max-width: 1024px) {
    width: 45%;
    height: 250px;
    margin: 10px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 200px;
    margin: 10px ;
  }
`;

export default VideoCareer;
